import Vue from 'vue'
import VueRouter from 'vue-router'

import Authorize from './views/Authorize.vue'

Vue.use(VueRouter)

/*
	One real route: /authorize — the OIDC authorization endpoint's UI (login +
	consent). The issuer's authorization_endpoint points here. Anything else
	falls through to it (it shows a friendly "start from the app" message when
	it has no client_id to work with).
*/
const routes = [
	{ path: '/authorize', component: Authorize },
	{ path: '*', redirect: '/authorize' }
]

export default new VueRouter({
	mode: 'history',
	routes: routes
})
